export default {
    recaptcha: null,
    onVerifyCallback: null,
    render() {
        return this.$scopedSlots.default({
            registerRecaptcha: this.registerRecaptcha,
            token: this.token,
            runRecaptcha: this.runRecaptcha,
            resetRecaptcha: this.resetRecaptcha,
            onVerify: this.onVerify,
        });
    },
    methods: {
        registerRecaptcha({ component }) {
            this.$options.recaptcha = component;
        },
        runRecaptcha(callback) {
            this.$options.recaptcha.execute();
            this.$options.onVerifyCallback = callback;
        },
        onVerify(token) {
            if (this.$options.onVerifyCallback) {
                this.$options.onVerifyCallback(token);
            }
        },
        resetRecaptcha() {
            this.$options.onVerifyCallback = null;
            this.$options.recaptcha.reset();
        },
    },
};
